import React from 'react';

export const ThreeDots = (props) => (
  <svg
    {...props}
    fill={props.fill || '#422981'}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.00008 6.08C6.92008 6.08 6.08008 6.96 6.08008 8C6.08008 9.08 6.92008 9.92 8.00008 9.92C9.04008 9.92 9.92008 9.08 9.92008 8C9.92008 6.96 9.04008 6.08 8.00008 6.08ZM6.08008 1.92C6.08008 3 6.92008 3.84 8.00008 3.84C9.04008 3.84 9.92008 3 9.92008 1.92C9.92008 0.88 9.04008 0 8.00008 0C6.92008 0 6.08008 0.88 6.08008 1.92ZM6.08008 14.08C6.08008 15.16 6.92008 16 8.00008 16C9.04008 16 9.92008 15.16 9.92008 14.08C9.92008 13.04 9.04008 12.16 8.00008 12.16C6.92008 12.16 6.08008 13.04 6.08008 14.08Z" />
  </svg>
);

export default ThreeDots;
